import { ON_DEMAND_PRODUCT, ONE_TO_MANY_PRODUCT, ONE_TO_ONE_PRODUCT } from 'constants/products.js';

// Catalog routes are product-specific. A Calls catalog flag must not make a
// /live/products URL valid, and the Live flag must not leak into /calls.
export const isCatalogSurfaceEnabled = ({
  selectedProduct,
  liveEnabled,
  callsEnabled,
  vodEnabled,
}) => {
  if (selectedProduct === ONE_TO_MANY_PRODUCT) return Boolean(liveEnabled);
  if (selectedProduct === ONE_TO_ONE_PRODUCT) return Boolean(callsEnabled);
  if (selectedProduct === ON_DEMAND_PRODUCT) return Boolean(vodEnabled);
  return false;
};
